import { ref } from 'vue'

const alerts = ref<Alert[]>([])

export type Alert = {
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
}
export function useAlerts() {
  return {
    alerts
  }
}
